import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { AuthhService } from "./../app/views/pages/services/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthhService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const accessToken = this.authService.getAccessToken();
        // Remove the Authorization header
        const modifiedReq = req.clone({
            withCredentials: true // Send cookies with the request
        });
        return next.handle(modifiedReq);
    }
}
